function setTitle({ input }) {
  let client = input.result.client
  window.document.title = client.name
}

export default setTitle



// WEBPACK FOOTER //
// ./src/modules/app/actions/setTitle.js